import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import {
  ReconciliationLogFilterForm,
  ReconciliationLogTable,
} from 'components/logsReconciliation'
import { Button } from 'components/common'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { ExportIcon } from 'components/icons'
import { downloadReconciliationLogs } from 'utils/api/logsApi'
import { FILTER_FIELD_RECONCILIATION_LOG } from 'components/logsReconciliation/reconciliationLogFilterForm'
import { FilterMeta, filterEmptyValues } from 'utils/helpers'
import { useQuery } from 'hooks'

const ReconciliationLog = () => {
  const [filterMeta, setFilterMeta] = useState<FilterMeta>()

  const { getQuery } = useQuery()

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = filterEmptyValues(
        getQuery(FILTER_FIELD_RECONCILIATION_LOG),
      )

      await downloadReconciliationLogs(
        Object.keys(logFilter).length > 0 ? logFilter : undefined,
      )
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Reconciliation Logs </title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Reconciliation Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_RECONCILIATION_LOG} />
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
        </div>
      </div>

      <ReconciliationLogFilterForm filterMeta={filterMeta} />
      <ReconciliationLogTable onFilterMeta={setFilterMeta} />
    </>
  )
}

export default ReconciliationLog
